import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {AppSettings} from '../../app-settings';
import {Observable, throwError} from 'rxjs';
import {Constants} from '../constants';
import {tap} from 'rxjs/operators';
import {University} from '../model/university';
import {Student} from '../model/student';
import {Course} from '../model/course';
import {AuthenticationService} from './authentication.service';
import Swal from 'sweetalert2';


@Injectable({
    providedIn: 'root'
})
export class DataManagementService {

    constructor(private http: HttpClient,
                private authenticationService: AuthenticationService) {
    }

    data = {'status': 'fail'};
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'x-access-token': this.authenticationService.getToken()
        })
    };


    getAllAPI(id) {
        let api;
        if (id === Constants.UNIVERSITY) {
            api = AppSettings.GET_UNIVERSITIES;
        } else if (id === Constants.PROGRAMMES) {
            api = AppSettings.GET_PROGRAMMES;
        } else if (id === Constants.ROUND_SETTINGS) {
            api = AppSettings.GET_ALL_ROUND_SETTINGS;
        } else if (id === Constants.TERM_SETTINGS) {
            api = AppSettings.GET_OUTGOING_TERMS;
        } else if (id === Constants.ADD_TERM_SETTINGS) {
            api = AppSettings.GET_DATA_TO_ADD_OUTGOING_TERMS;
        } else if (id === Constants.ACTIONS) {
            api = AppSettings.GET_ACTIONS;
        } else if (id === Constants.STUDENT_HOME) {
            api = AppSettings.GET_DATA_FOR_OUTGOING_STUDENT_HOME;
        } else if (id === Constants.ACADEMIC_YEAR) {
            api = AppSettings.GET_ACADEMIC_YEAR;
        } else if (id === Constants.OUTGOING_BATCH) {
            api = AppSettings.GET_OUTGOING_BATCH;
        } else if (id === Constants.ROUNDS_FILTER) {
            api = AppSettings.GET_ROUNDS_FILTER;
        }
        return api;
    }

    getOneAPI(const_id, id) {
        let api;
        if (const_id === Constants.ROUND_SETTINGS) {
            api = AppSettings.GET_TERMS_FOR_ROUNDS + id;
        } else if (const_id === Constants.EDIT_TERM_SETTINGS) {
            api = AppSettings.GET_DATA_TO_EDIT_TERM + id;
        } else if (const_id === Constants.BIDDING_RESPONSE) {
            api = AppSettings.GET_BIDDING_RESULTS + id;
        } else if (const_id === Constants.PROCESSING_OUTPUT) {
            api = AppSettings.GET_PROCESSING_OUTPUT + id;
        } else if (const_id === Constants.BIDDING_RESPONSE_REPORT) {
            api = AppSettings.GET_BIDDING_RESULTS_REPORT + id;
        } else if (const_id === Constants.PROCESSING_OUTPUT_REPORT) {
            api = AppSettings.GET_PROCESSING_OUTPUT_REPORT + id;
        } else if (const_id === Constants.OIA_HOME) {
            api = AppSettings.GET_OIA_HOME_DETAILS + id;
        } else if (const_id === Constants.UNIVERSITY) {
            api = AppSettings.GET_UNIVERSITY_DETAILS_TO_EDIT + id;
        } else if (const_id === Constants.STUDENT_RANK) {
            api = AppSettings.GET_STUDENT_RANKS_FOR_REPORT + id;
        } else if (const_id === Constants.STUDENT_REGISTRATION_STATUS) {
            api = AppSettings.GET_STUDENT_REGISTRATION_STATUS_FOR_REPORT + id;
        } else if (const_id === Constants.REGISTERED_STUDENTS) {
            api = AppSettings.GET_REGISTERED_STUDENTS + id;
        } else if (const_id === Constants.GET_REGISTERED_STUDENT_DETAILS) {
            api = AppSettings.GET_REGISTERED_STUDENT_DETAILS + id;
        } else if (const_id === Constants.PRACTICE_ROUND_UNIVERSITY_PREFERENCES) {
            api = AppSettings.GET_PRACTICE_ROUND_UNIVERSITY_PREFERENCES + id;
        } else if (const_id === Constants.PRACTICE_ROUND_UNIVERSITY_WISE_ALLOTMENT) {
            api = AppSettings.GET_OUTGOING_PRACTICE_ROUND_ALLOTMENT_DETAILS + id;
        } else if (const_id === Constants.UNIVERSITY_PREFERENCES) {
            api = AppSettings.GET_UNIVERSITY_PREFERENCES + id;
        } else if (const_id === Constants.UNIVERSITY_WISE_ALLOTMENT) {
            api = AppSettings.GET_OUTGOING_ALLOTMENT_DETAILS + id;
        } else if (const_id === Constants.ROUND_TWO_ALLOTMENT) {
            api = AppSettings.GET_ROUND_TWO_ALLOTMENT + id;
        } else if (const_id === Constants.FINAL_UNIVERSITY_ALLOTMENT) {
            api = AppSettings.GET_FINAL_UNIVERSITY_ALLOTMENT + id;
        } else if (const_id === Constants.FINAL_UNIVERSITY_WISE_ALLOTMENT) {
            api = AppSettings.GET_FINAL_UNIVERSITY_WISE_ALLOTMENT_REPORT + id;
        } else if (const_id === Constants.DIVERSITY_REPORT) {
            api = AppSettings.GET_DIVERSITY_REPORT + id;
        } else if (const_id === Constants.BALANCE_OF_TRADE_REPORT) {
            api = AppSettings.GET_BALANCE_OF_TRADE_REPORT + id;
        } else if (const_id === Constants.STUDENT) {
            api = AppSettings.GET_OUTGOING_STUDENTS + id;
        } else if (const_id === Constants.FINAL_OPTED_OUT_STUDENTS) {
            api = AppSettings.GET_FINAL_OPTED_OUT_STUDENTS_REPORT + id;
        }else if (const_id === Constants.DREAM_UNIVERSITY_PREFERNCES) {
            api = AppSettings.GET_DREAM_UNIVERSITY_PREFERENCES + id;
        }
        return api;
    }

    getBulkUploadAPI(id) {
        let api;
        if (id === Constants.STUDENT) {
            api = AppSettings.UPLOAD_OUTGOING_STUDENTS;
        } else if (id === Constants.UNIVERSITY) {
            api = AppSettings.UPLOAD_UNIVERSITIES;
        } else if (id === Constants.ADD_TERM_SETTINGS) {
            api = AppSettings.ADD_TERMS;
        } else if (id === Constants.EDIT_TERM_SETTINGS) {
            api = AppSettings.EDIT_TERMS;
        } else if (id === Constants.ROUND_SETTINGS) {
            api = AppSettings.ADD_ROUNDS;
        } else if (id === Constants.UPDATE_ROUND_SETTINGS) {
            api = AppSettings.UPDATE_ROUND_SETTINGS;
        } else if (id === Constants.ACTIONS) {
            api = AppSettings.UPLOAD_ACTIONS;
        } else if (id === Constants.STUDENT_HOME) {
            api = AppSettings.TOGGLE_FAVOURITE;
        } else if (id === Constants.EDIT_UNIVERSITY) {
            api = AppSettings.EDIT_UNIVERSITY;
        } else if (id === Constants.REGISTERED_STUDENTS) {
            api = AppSettings.UPDATE_STUDENT_STATUS;
        } else if (id === Constants.EDIT_REGISTERED_STUDENT) {
            api = AppSettings.UPDATE_STUDENT_REGISTRATION_DETAILS;
        } else if (id === Constants.GENERATE_PREFERENCES) {
            api = AppSettings.GENERATE_PREFERENCES;
        } else if (id === Constants.VALIDATE_ALL_REGISTRATIONS) {
            api = AppSettings.VALIDATE_ALL_REGISTRATIONS;
        } else if (id === Constants.TERM_SETTINGS) {
            api = AppSettings.UPLOAD_OUTGOING_TERM_SETTINGS;
        } else if (id === Constants.PAST_DATA) {
            api = AppSettings.UPLOAD_PAST_DATA;
        }
        return api;
    }

    getClearAPI(id) {
        let api;
        if (id === Constants.STUDENT) {
            api = AppSettings.CLEAR_OUTGOING_STUDENTS;
        } else if (id === Constants.UNIVERSITY) {
            api = AppSettings.CLEAR_UNIVERSITIES;
        } else if (id === Constants.TERM_SETTINGS) {
            api = AppSettings.CLEAR_TERMS;
        } else if (id === Constants.ACTIONS) {
            api = AppSettings.CLEAR_ACTIONS;
        } else if (id === Constants.CLEAR_ALL) {
            api = AppSettings.CLEAR_ALL;
        }
        return api;
    }

    getClearAPIByParameter(id) {
        let api;
        if (id === Constants.DELETE_POC) {
            api = AppSettings.DELETE_POC;
        }
        if (id === Constants.DELETE_ROUND) {
            api = AppSettings.DELETE_ROUND;
        }
        return api;
    }

    getUpdateAPI(id) {
        let api;
        if (id === Constants.STUDENT) {
            api = AppSettings.MODIFY_OUTGOING_STUDENT;
        } else if (id === Constants.UNIVERSITY) {
            api = AppSettings.MODIFY_UNIVERSITY;
        } else if (id === Constants.TERM_SETTINGS) {
            api = AppSettings.MODIFY_TERMS;
        }
        return api;
    }

    getJavaPostAPIs(id) {
        let api;
        if (id === Constants.GENERATE_RANKS) {
            api = AppSettings.GENERATE_RANKS;
        } else if (id === Constants.GENERATE_RESULTS) {
            api = AppSettings.GENERATE_RESULTS;
        } else if (id === Constants.STUDENT_REGISTRATION) {
            api = AppSettings.CREATE_UPDATE_OUTGOING_STUDENT_REGISTRATION;
        } else if (id === Constants.MODIFY_ROUND2_UNIVERSITY) {
            api = AppSettings.MODIFY_ROUND2_UNIVERSITY;
        } else if (id === Constants.DELETE_EXPERIENCE) {
            api = AppSettings.DELETE_EXPERIENCE;
        } else if (id === Constants.CLEAR_RANKS) {
            api = AppSettings.CLEAR_RANKS;
        } else if (id === Constants.CLEAR_RESULTS) {
            api = AppSettings.CLEAR_RESULTS;
        } else if (id === Constants.FINAL_STUDENT_REGISTRATION) {
            api = AppSettings.FINAL_CREATE_UPDATE_OUTGOING_STUDENT_REGISTRATION;
        } else if (id === Constants.FEEDBACK) {
            api = AppSettings.UPLOAD_OUTGOING_STUDENT_FEEDBACK;
        } else if (id === Constants.SEND_ROUND_RESULT) {
            api = AppSettings.SEND_ROUND_RESULT;
        } else if (id === Constants.UNIVERSITY) {
            api = AppSettings.DELETE_FS_OR_MOU_DOCUMENT;
        } else if (id === Constants.ADD_NOMINATION) {
            api = AppSettings.ADD_NOMINATION;
        } else if (id === Constants.EDIT_NOMINATION) {
            api = AppSettings.EDIT_NOMINATION;
        } else if (id === Constants.CHANGE_STUDENT_STATE) {
            api = AppSettings.CHANGE_STUDENT_STATE;
        } else if (id === Constants.INCOMING_TERM_SETTINGS) {
            api = AppSettings.CREATE_OR_UPDATE_INCOMING_TERM_SETTINGS;
        } else if (id === Constants.INCOMING_STUDENT_REGISTRATION) {
            api = AppSettings.UPDATE_INCOMING_STUDENT_REGISTRATION;
        } else if (id === Constants.FINAL_INCOMING_STUDENT_REGISTRATION) {
            api = AppSettings.FINAL_UPDATE_INCOMING_STUDENT_REGISTRATION;
        } else if (id === Constants.INCOMING_STUDENT_FILE_DELETE) {
            api = AppSettings.DELETE_INCOMING_STUDENT_FILE;
        } else if (id === Constants.SEND_NOMINATION_EMAIL) {
            api = AppSettings.SEND_NOMINATION_EMAIL;
        } else if (id === Constants.LOGIN_DETAILS_TO_POC) {
            api = AppSettings.LOGIN_DETAILS_TO_POC;
        } else if (id === Constants.DELETE_INCOMING_TERM_SETTINGS) {
            api = AppSettings.DELETE_INCOMING_TERM_SETTINGS;
        } else if (id === Constants.ACCEPT_NOMINATION) {
            api = AppSettings.ACCEPT_NOMINATION;
        } else if (id === Constants.REJECT_NOMINATION) {
            api = AppSettings.REJECT_NOMINATION;
        } else if (id === Constants.OUTGOING_STUDENT_FILE_DELETE) {
            api = AppSettings.DELETE_OUTGOING_STUDENT_FILE;
        } else if (id === Constants.CHANGE_DREAM_UNIVERSITY) {
            api = AppSettings.CHANGE_DREAM_UNIVERSITY;
        } else if (id === Constants.CONFIRM_UNIVERSITY) {
            api = AppSettings.CONFIRM_UNIVERSITY;
        } else if (id === Constants.UN_CONFIRM_UNIVERSITY) {
            api = AppSettings.UN_CONFIRM_UNIVERSITY;
        } else if (id === Constants.OPT_OUT_FROM_EXCHANGE) {
            api = AppSettings.OPT_OUT_FROM_EXCHANGE;
        } else if (id === Constants.SELECT_PREVIOUS_ROUND_PREFERENCES) {
            api = AppSettings.SELECT_PREVIOUS_ROUND_PREFERENCES;
        } else if (id === Constants.LOGIN_DETAILS_TO_POC_BY_POC_ID) {
            api = AppSettings.LOGIN_DETAILS_TO_POC_BY_POC_ID;
        } else if (id === Constants.IIMB_EMAILS) {
            api = AppSettings.UPLOAD_IIMB_EMAILS;
        }else if (id === Constants.ADD_STUDENT_TO_BIDDING_RESULTS) {
            api = AppSettings.ADD_STUDENT_TO_BIDDING_RESULTS;
        }else if (id === Constants.UPDATE_INCOMING_TERM_VISA_SETTING) {
            api = AppSettings.UPDATE_INCOMING_TERM_VISA_SETTING;
        }else if (id === Constants.ADD_INCOMING_TERM_VISA_SETTING) {
            api = AppSettings.ADD_INCOMING_TERM_VISA_SETTING;
        }else if(id === Constants.INCOMING_STUDENT_REGISTRATION_BY_TERM_ID){
            api = AppSettings.INCOMING_STUDENT_REGISTRATION_BY_TERM_ID;
        }
        return api;
    }

   
    getJavaGetAPIs(id) {
        let api;
        if (id === Constants.ROUND2_DATA) {
            api = AppSettings.GET_ROUND2_DATA;
        } else if (id === Constants.STUDENT_HOME) {
            api = AppSettings.GET_OUTGOING_STUDENT_DATA_FOR_HOME;
        } else if (id === Constants.STUDENT_GIVEN_AND_NOT_GIVEN_PREFERENCES) {
            api = AppSettings.GET_STUDENT_GIVEN_AND_NOT_GIVEN_PREFERENCES;
        } else if (id === Constants.STUDENT_REGISTRATION) {
            api = AppSettings.GET_OUTGOING_STUDENT_REGISTRATION;
        } else if (id === Constants.GET_DOCUMENT_PAGE_DATE) {
            api = AppSettings.GET_DOCUMENT_PAGE_DATE;
        } else if (id === Constants.DOWNLOAD_DOCUMENT) {
            api = AppSettings.DOWNLOAD_DOCUMENT;
        } else if (id === Constants.GET_UNIVERSITY_WISE_STUDENT_LIST) {
            api = AppSettings.GET_UNIVERSITY_WISE_STUDENT_LIST;
        } else if (id === Constants.FEEDBACK) {
            api = AppSettings.GET_FEEDBACK_QUESTIONS;
        } else if (id === Constants.NOMINATIONS) {
            api = AppSettings.GET_NOMINATIONS;
        } else if (id === Constants.INCOMING_TERM_SETTINGS) {
            api = AppSettings.GET_INCOMING_TERM_SETTINGS;
        } else if (id === Constants.ADD_INCOMING_TERM_SETTINGS) {
            api = AppSettings.GET_DATA_TO_ADD_INCOMING_TERM_SETTINGS;
        } else if (id === Constants.EDIT_INCOMING_TERM_SETTINGS) {
            api = AppSettings.GET_DATA_TO_EDIT_INCOMING_TERM_SETTINGS;
        } else if (id === Constants.INCOMING_STUDENT_HOME_DETAILS) {
            api = AppSettings.GET_INCOMING_STUDENT_HOME_DETAILS;
        } else if (id === Constants.POC_HOME_DETAILS) {
            api = AppSettings.GET_POC_HOME_DETAILS;
        } else if (id === Constants.INCOMING_STUDENT_REGISTRATION) {
            api = AppSettings.GET_INCOMING_STUDENT_REGISTRATION_DETAILS;
        } else if (id === Constants.INCOMING_REGISTRATIONS) {
            api = AppSettings.GET_INCOMING_REGISTRATIONS;
        } else if (id === Constants.INCOMING_POC) {
            api = AppSettings.GET_ALL_INCOMING_POCS;
        } else if (id === Constants.GET_INCOMING_STUDENT_DOCUMENT_DATA) {
            api = AppSettings.GET_INCOMING_STUDENT_DOCUMENT_DATA;
        } else if (id === Constants.DOWN_INCOM_STU_DOC) {
            api = AppSettings.DOWNLOAD_INCOMING_STUDENT_DOCUMENTS;
        }else if (id === Constants.UNIVERSITIES_BY_OUTGOING_ROUND_ID) {
            api = AppSettings.UNIVERSITIES_BY_OUTGOING_ROUND_ID;
        }else if (id === Constants.STUDENTS_BY_OUTGOING_ROUND_ID) {
            api = AppSettings.STUDENTS_BY_OUTGOING_ROUND_ID;
        }else if( id === Constants.GET_INCOMING_TERM_VISA_SETTINGS) {
            api = AppSettings.GET_INCOMING_TERM_VISA_SETTINGS;
        }else if( id === Constants.GET_ALL_ACADEMIC_YEARS) {
            api = AppSettings.GET_ALL_ACADEMIC_YEARS;
        }else if( id === Constants.GET_INCOMING_TERM_VISA_SETTINGS_BY_ID) {
            api = AppSettings.GET_INCOMING_TERM_VISA_SETTINGS_BY_ID;
        }else if( id === Constants.GET_INCOMING_TERM_SETTINGS_FOR_VISA) {
            api = AppSettings.GET_INCOMING_TERM_SETTINGS_FOR_VISA;
        }
        return api;
    }

    downloadFile(body: any, api: string) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'x-access-token': this.authenticationService.getToken()
        });

        return this.http.post(api, body, { headers: headers, responseType: 'blob' });
    }

    getAll(id): Observable<any> {
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'x-access-token': this.authenticationService.getToken()
            })
        };
        const api = this.getAllAPI(id);
        return this.http.get(AppSettings.NODE_API + api, this.httpOptions)
            .pipe(
                tap(
                    data => {
                        if (data.data.hasOwnProperty('token') && data.data.token === false) {
                            Swal({
                                type: 'warning',
                                title: 'Token expired',
                                text: 'Session is expired please login again.'
                            });
                            this.authenticationService.logout();
                        }
                    },
                    errors => this.handleError(errors)
                )
            );
    }

    getOne(constId, id): Observable<any> {
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'x-access-token': this.authenticationService.getToken()
            })
        };
        const api = this.getOneAPI(constId, id);
        return this.http.get(AppSettings.NODE_API + api, this.httpOptions)
            .pipe(
                tap(
                    data => {
                        if (data.data.hasOwnProperty('token') && data.data.token === false) {
                            Swal({
                                type: 'warning',
                                title: 'Token expired',
                                text: 'Session is expired please login again.'
                            });
                            this.authenticationService.logout();
                        }
                    },
                    errors => this.handleError(errors)
                )
            );
    }

    bulkUpload(body, id): Observable<any> {
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'x-access-token': this.authenticationService.getToken()
            })
        };
        const api = this.getBulkUploadAPI(id);
        return this.http.post(AppSettings.NODE_API + api, body, this.httpOptions)
            .pipe(
                tap(
                    data => {
                        if (data.data.hasOwnProperty('token') && data.data.token === false) {
                            Swal({
                                type: 'warning',
                                title: 'Token expired',
                                text: 'Session is expired please login again.'
                            });
                            this.authenticationService.logout();
                        }
                    },
                    errors => this.handleError(errors)
                )
            );
    }

    toggleUniversity(body: {}): Observable<any> {
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'x-access-token': this.authenticationService.getToken()
            })
        };
        return this.http.post(AppSettings.JAVA_API + AppSettings.TOGGLE_FAVOURITE, body, this.httpOptions)
            .pipe(
                tap(
                    data => {
                        if (data.hasOwnProperty('token') && data.token === false) {
                            Swal({
                                type: 'warning',
                                title: 'Token expired',
                                text: 'Session is expired please login again.'
                            });
                            this.authenticationService.logout();
                        }
                    },
                    errors => this.handleError(errors)
                )
            );
    }

    clearData(id): Observable<any> {
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'x-access-token': this.authenticationService.getToken()
            })
        };
        const api = this.getClearAPI(id);
        return this.http.get(AppSettings.NODE_API + api, this.httpOptions)
            .pipe(
                tap(
                    data => {
                        if (data.data.hasOwnProperty('token') && data.data.token === false) {
                            Swal({
                                type: 'warning',
                                title: 'Token expired',
                                text: 'Session is expired please login again.'
                            });
                            this.authenticationService.logout();
                        }
                    },
                    errors => this.handleError(errors)
                )
            );
    }

    clearDataByParameter(body, id): Observable<any> {
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'x-access-token': this.authenticationService.getToken()
            })
        };
        const api = this.getClearAPIByParameter(id);
        return this.http.post(AppSettings.NODE_API + api, body, this.httpOptions)
            .pipe(
                tap(
                    data => {
                        if (data.data.hasOwnProperty('token') && data.data.token === false) {
                            Swal({
                                type: 'warning',
                                title: 'Token expired',
                                text: 'Session is expired please login again.'
                            });
                            this.authenticationService.logout();
                        }
                    },
                    errors => this.handleError(errors)
                )
            );
    }

    updateData(body, id): Observable<any> {
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'x-access-token': this.authenticationService.getToken()
            })
        };
        const api = this.getUpdateAPI(id);
        return this.http.post(AppSettings.NODE_API + api, body, this.httpOptions)
            .pipe(
                tap(
                    data => {
                        if (data.data.hasOwnProperty('token') && data.data.token === false) {
                            Swal({
                                type: 'warning',
                                title: 'Token expired',
                                text: 'Session is expired please login again.'
                            });
                            this.authenticationService.logout();
                        }
                    },
                    errors => this.handleError(errors)
                )
            );
    }

    createOrUpdateStudentPreferences(body): Observable<any> {
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'x-access-token': this.authenticationService.getToken()
            })
        };
        return this.http.post(AppSettings.JAVA_API + AppSettings.CREATE_OR_UPDATE_PREFERENCE, body, this.httpOptions)
            .pipe(
                tap(
                    data => {
                        if (data.hasOwnProperty('token') && data.token === false) {
                            Swal({
                                type: 'warning',
                                title: 'Token expired',
                                text: 'Session is expired please login again.'
                            });
                            this.authenticationService.logout();
                        }
                    },
                    errors => this.handleError(errors)
                )
            );
    }

    deleteStudentPreferences(body): Observable<any> {
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'x-access-token': this.authenticationService.getToken()
            })
        };
        return this.http.post(AppSettings.JAVA_API + AppSettings.DELETE_PREFERENCES, body, this.httpOptions)
            .pipe(
                tap(
                    data => {
                        if (data.hasOwnProperty('token') && data.token === false) {
                            Swal({
                                type: 'warning',
                                title: 'Token expired',
                                text: 'Session is expired please login again.'
                            });
                            this.authenticationService.logout();
                        }
                    },
                    errors => this.handleError(errors)
                )
            );
    }

    javaGetDataCallByParameter(constId, parameter): Observable<any> {
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'x-access-token': this.authenticationService.getToken()
            })
        };
        const api = this.getJavaGetAPIs(constId);
        return this.http.get(AppSettings.JAVA_API + api + parameter, this.httpOptions)
            .pipe(
                tap(
                    data => {
                        if (data.hasOwnProperty('token') && data.token === false) {
                            Swal({
                                type: 'warning',
                                title: 'Token expired',
                                text: 'Session is expired please login again.'
                            });
                            this.authenticationService.logout();
                        }
                    },
                    errors => this.handleError(errors)
                )
            );
    }

    javaGetDataCall(constId): Observable<any> {
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'x-access-token': this.authenticationService.getToken()
            })
        };
        const api = this.getJavaGetAPIs(constId);
        return this.http.get(AppSettings.JAVA_API + api, this.httpOptions)
            .pipe(
                tap(
                    data => {
                        if (data.hasOwnProperty('token') && data.token === false) {
                            Swal({
                                type: 'warning',
                                title: 'Token expired',
                                text: 'Session is expired please login again.'
                            });
                            this.authenticationService.logout();
                        }
                    },
                    errors => this.handleError(errors)
                )
            );
    }

    javaPostDataCall(body, api_id): Observable<any> {
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'x-access-token': this.authenticationService.getToken()
            })
        };
        const api = this.getJavaPostAPIs(api_id);
        return this.http.post(AppSettings.JAVA_API + api, body, this.httpOptions).pipe(
            tap(
                data => {
                    if (data.hasOwnProperty('token') && data.token === false) {
                        Swal({
                            type: 'warning',
                            title: 'Token expired',
                            text: 'Session is expired please login again.'
                        });
                        this.authenticationService.logout();
                    }
                },
                errors => this.handleError(errors)
            )
        );
    }

    javaDocumentUploadCall(formData): Observable<any> {
        this.httpOptions = {
            headers: new HttpHeaders({
                'Accept': 'application/json',
                'x-access-token': this.authenticationService.getToken()
            })
        };
        return this.http.post(AppSettings.JAVA_API + AppSettings.DOCUMENT_UPLOAD, formData, this.httpOptions)
            .pipe(
                tap(
                    data => {
                        if (data.hasOwnProperty('token') && data.token === false) {
                            Swal({
                                type: 'warning',
                                title: 'Token expired',
                                text: 'Session is expired please login again.'
                            });
                            this.authenticationService.logout();
                        }
                    },
                    errors => this.handleError(errors)
                )
            );
    }

    javaUploadFSOrMOUFile(formData): Observable<any> {
        this.httpOptions = {
            headers: new HttpHeaders({
                'Accept': 'application/json',
                'x-access-token': this.authenticationService.getToken()
            })
        };
        return this.http.post(AppSettings.JAVA_API + AppSettings.UPLOAD_FS_OR_MOU_FILE, formData, this.httpOptions)
            .pipe(
                tap(
                    data => {
                        if (data.hasOwnProperty('token') && data.token === false) {
                            Swal({
                                type: 'warning',
                                title: 'Token expired',
                                text: 'Session is expired please login again.'
                            });
                            this.authenticationService.logout();
                        }
                    },
                    errors => this.handleError(errors)
                )
            );
    }

    javaUploadIncomingStudentDocument(formData): Observable<any> {
        this.httpOptions = {
            headers: new HttpHeaders({
                'Accept': 'application/json',
                'x-access-token': this.authenticationService.getToken()
            })
        };
        return this.http.post(AppSettings.JAVA_API + AppSettings.UPLOAD_INCOMING_STUDENT_FILE, formData, this.httpOptions)
            .pipe(
                tap(
                    data => {
                        if (data.hasOwnProperty('token') && data.token === false) {
                            Swal({
                                type: 'warning',
                                title: 'Token expired',
                                text: 'Session is expired please login again.'
                            });
                            this.authenticationService.logout();
                        }
                    },
                    errors => this.handleError(errors)
                )
            );
    }

    checkIfTokenExpired(data) {
        if (data.data.hasOwnProperty('epas_token') && data.data.token === false) {
            this.authenticationService.logout();
        }
    }

    getStaticDataForRound(student_id, round_id): Observable<any> {
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'x-access-token': this.authenticationService.getToken()
            })
        };
        // console.log(api);
        return this.http.get(AppSettings.JAVA_API + AppSettings.GET_STATIC_DATA_FOR_BIDDING_ROUND + round_id + '/' +
            student_id, this.httpOptions)
            .pipe(
                tap(
                    data => {
                        if (data.hasOwnProperty('token') && data.token === false) {
                            Swal({
                                type: 'warning',
                                title: 'Token expired',
                                text: 'Session is expired please login again.'
                            });
                            this.authenticationService.logout();
                        }
                    },
                    errors => this.handleError(errors)
                )
            );
    }

    getExpectedUniversityForRound(student_id, round_id): Observable<any> {
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'x-access-token': this.authenticationService.getToken()
            })
        };
        return this.http.get(AppSettings.JAVA_API + AppSettings.GET_EXPECTED_UNIVERSITY_FOR_BIDDING_ROUND + round_id + '/' +
            student_id, this.httpOptions)
            .pipe(
                tap(
                    data => {
                        if (data.hasOwnProperty('token') && data.token === false) {
                            Swal({
                                type: 'warning',
                                title: 'Token expired',
                                text: 'Session is expired please login again.'
                            });
                            this.authenticationService.logout();
                        }
                    },
                    errors => this.handleError(errors)
                )
            );
    }

    getDynamicDataForConfirmationRound(student_id, round_id, previous_round_id, is_practice_round): Observable<any> {
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'x-access-token': this.authenticationService.getToken()
            })
        };
        // console.log(api);
        return this.http.get(AppSettings.JAVA_API + AppSettings.GET_DATA_FOR_CONFIRMATION_ROUND + round_id + '/' +
            previous_round_id + '/' + student_id + '/' + is_practice_round, this.httpOptions)
            .pipe(
                tap(
                    data => {
                        if (data.hasOwnProperty('token') && data.token === false) {
                            Swal({
                                type: 'warning',
                                title: 'Token expired',
                                text: 'Session is expired please login again.'
                            });
                            this.authenticationService.logout();
                        }
                    },
                    errors => this.handleError(errors)
                )
            );
    }

    getUniversities(): Observable<any> {
        return this.http.get('assets/data/universities.json')
            .pipe(
                tap(res => <University[]>res.data)
            );
    }

    getStudents(): Observable<any> {
        return this.http.get('assets/data/students.json')
            .pipe(
                tap(res => <Student[]>res.data)
            );
    }

    getCourses(): Observable<any> {
        return this.http.get('assets/data/courses.json')
            .pipe(
                tap(res => <Course[]>res.data)
            );
    }

    getPastStudents(): Observable<any> {
        return this.http.get('assets/data/past-students.json')
            .pipe(
                tap(res => <Student[]>res.data)
            );
    }

    private handleError(err: any) {
        console.error('An error occurred', err.message);
        return throwError(err || 'Server error');
    }
}
